import React, {useEffect, useState} from 'react';
import {BUTTON_TYPES, IProductsList, MODAL_STEPS} from "../../types";
import {Button, Select} from "../common";

interface ISelect {
  id?: string | number; label?: string
}

const ReqFirstStep = (
  { data, onClose, handleChangeStep }:
  {
    data: IProductsList | null | undefined;
    onClose: () => void;
    handleChangeStep: (step: string | null, data: any) => void;
  }
) => {
  const [bankData, setBankData] = useState<Array<ISelect>>([]);
  const [activeBankData, setActiveBankData] = useState<ISelect>({});
  const [productData, setProductData] = useState<Array<ISelect> | []>([]);
  const [activeProductData, setActiveProductData] = useState<ISelect>({});

  useEffect(() => {
    if (!data) return;

    const arrayOfBanks: Array<any> = [];

    data?.banks?.forEach(({ id, name}) => {
      const obj = {
        id,
        label: name
      };

      arrayOfBanks.push(obj);
    });

    setBankData(arrayOfBanks)

  }, [data])

  const handleSelectBank = (e: string) => {
    const isSelectBank = data?.banks?.find(i => i.id.toString() === e.toString());

    if (isSelectBank) {
      const obj = {
        id: isSelectBank?.id,
        label: isSelectBank?.name,
      };

      setActiveBankData(obj);
      setActiveProductData({});

      if (isSelectBank?.types?.length) {
        const arrayOfProduct: Array<any> = [];

        isSelectBank?.types?.forEach(({name, label}) => {
          arrayOfProduct.push({
            id: name,
            label
          })
        });

        setProductData(arrayOfProduct)
      } else {
        setProductData([]);
      }
    }

  };

  const handleSelectProduct = (e: string) => {
    const isSelectProduct = productData?.find(i => i.id === e);

    if (isSelectProduct) {
      const { id, label } = isSelectProduct;
      setActiveProductData(({ id, label }));
    }
  }

  const onContinue = () => {
    const data = {
      bank: activeBankData?.id,
      type: activeProductData?.id
    };

    handleChangeStep(null, data);
  }

  return (
    <>
      <h2 className="text-[18px] leading-[24px] text-black font-bold mb-5">Шаг 1</h2>
      <p className="text-[14px] leading-[24px] text-black font-medium mb-1">Банк</p>
      <Select onChange={handleSelectBank} value={bankData} activeData={activeBankData} />
      {!!Object.keys(activeBankData)?.length
        ? productData?.length
          ? <>
              <p className="text-[14px] leading-[24px] text-black font-medium mt-2 mb-1">Продукт</p>
              <Select onChange={handleSelectProduct} value={productData} activeData={activeProductData} />
            </>
          : <p className="text-black mt-2">Нет продуктов</p>
        : null
      }
      <div className="mt-6 flex items-center">
        <Button
          title={'Далее'}
          type={BUTTON_TYPES.SECONDARY}
          disabled={!Object.keys(activeBankData)?.length || !Object.keys(activeProductData)?.length}
          onClick={onContinue}
        />
        <Button
          title={'Отмена'}
          type={BUTTON_TYPES.GRAY}
          onClick={onClose} className="ml-2"
        />
      </div>
    </>
  )
}

export default ReqFirstStep;
